export const device = {
  tablet: 'only screen and (max-width: 768px)',
  desktop: 'only screen and (max-width: 1920px)'
};
